import React from 'react';
import ReactDOM from 'react-dom/client';
import '@/lib/http';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import '@/index.css';
import App from '@/App';
import { hydrater, demarrerSync } from '@/lib/store';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));

// La base partagée (MongoDB) est chargée avant le premier rendu : localStorage
// n'est plus qu'un cache local synchronisé entre les postes.
hydrater().then((res) => {
  // Avant connexion, la base répond 401 : ce n'est pas une panne, on ne crie pas.
  if (!res.connecte && !String(res.erreur ?? '').includes('401')) {
    console.warn('Base partagée injoignable — fonctionnement sur le cache local.', res.erreur);
  }
  demarrerSync();
  root.render(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </React.StrictMode>
  );
});
